import { QueryKeys } from 'queries/types'

const ROOT = 'user'

export const userKeys = {
  root: [ROOT],

  permissions: {
    all: [ROOT, 'permissions'],
    byUserId: (userId?: string) => [ROOT, 'permissions', userId],
  },

  profile: (userId?: string) => [ROOT, 'userProfile', userId],
  intercomJwt: (userId?: string) => [ROOT, 'intercomJwt', userId],
} satisfies QueryKeys
